import React from "react";

import {
  formatEventDate,
  getEventType,
} from "../utils/convocationsAdmin.utils";

import { EventStatusPill, EventTypeBadge } from "../ui/EventBadges";

import ConvocationActions from "./ConvocationActions";
import ConvocationsEmptyState from "./ConvocationsEmptyState";
import EventIdentity from "./EventIdentity";

function DesktopSkeleton() {
  return (
    <div className="space-y-3 p-5">
      {[1, 2, 3, 4, 5].map((item) => (
        <div
          key={item}
          className="h-20 animate-pulse rounded-2xl bg-slate-100 dark:bg-slate-800"
        />
      ))}
    </div>
  );
}

export default function ConvocationsDesktopTable({
  rows,
  loading,
  onRegister,
  onRegisterByGroup,
  onUnregister,
  onView,
}) {
  return (
    <section className="hidden overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900 lg:block">
      {loading ? (
        <DesktopSkeleton />
      ) : rows.length === 0 ? (
        <ConvocationsEmptyState />
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[1180px] table-fixed text-sm">
            <thead className="bg-slate-50/90 dark:bg-slate-950/60">
              <tr className="text-left text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400">
                <th className="w-[15%] px-5 py-4 font-semibold">Date</th>

                <th className="w-[27%] px-5 py-4 font-semibold">Événement</th>

                <th className="w-[15%] px-5 py-4 font-semibold">Type</th>

                <th className="w-[11%] px-5 py-4 font-semibold">Statut</th>

                <th className="w-[32%] px-5 py-4 font-semibold">Actions</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
              {rows.map((event) => {
                return (
                  <tr
                    key={event.id}
                    className="align-top transition hover:bg-blue-50/40 dark:hover:bg-slate-800/40"
                  >
                    <td className="px-5 py-5">
                      <p className="font-medium capitalize text-slate-800 dark:text-slate-200">
                        {formatEventDate(event.start)}
                      </p>
                    </td>

                    <td className="px-5 py-5">
                      <EventIdentity event={event} />
                    </td>

                    <td className="px-5 py-5">
                      <EventTypeBadge type={getEventType(event)} />
                    </td>

                    <td className="px-5 py-5">
                      <EventStatusPill start={event.start} />
                    </td>

                    <td className="px-5 py-5">
                      <ConvocationActions
                        event={event}
                        onRegister={onRegister}
                        onRegisterByGroup={onRegisterByGroup}
                        onUnregister={onUnregister}
                        onView={onView}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
